'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'window-frame';
var width = 512;
var height = 512;
var aliases = [129695];
var unicode = 'e04f';
var svgPathData = 'M240 288l0 192L64 480l0-192 176 0zm32 192l0-192 176 0 0 192-176 0zm208 0l0-416c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 416-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 384 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zM448 256l-176 0 0-224 144 0c17.7 0 32 14.3 32 32l0 192zM96 32l144 0 0 224L64 256 64 64c0-17.7 14.3-32 32-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWindowFrame = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;